<template>
    <div>
        <a-modal centered v-if="step == '2_password'" :bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
            <!-- header -->
            <div class="custom-modal-header p-16">
                <span class="fs-20 fw-600 color-white">
                    {{ $t('รหัสผ่าน') }}
                </span>
            </div>
            <div class="p-16-16-0-16 text-center">
                <span class="fs-16 black"> กรุณาใส่รหัส PIN 6 หลัก... </span>
            </div>
            <!-- footer -->
            <div class="custom-modal-footer text-center">
                <a-button key="back" class="fs-20 primary-btn" @click="cancel()">
                    {{ $t('ปิดหน้าต่าง') }}
                </a-button>
            </div>
        </a-modal>
        <a-modal centered v-if="step == 'custom_without_header'" :bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
            <div class="custom-modal-header p-16">
                <span class="fs-20 fw-600 color-white">
                    {{ data.title && data.title != '' ? data.title : 'แจ้งเตือน' }}
                </span>
            </div>
            <div class="p-16-16-0-16 text-center">
                <span class="fs-16 black"> {{ data.message }} </span>
            </div>
            <!-- footer -->
            <div class="custom-modal-footer text-center">
                <a-button key="back" class="fs-20 primary-btn" @click="cancel()">
                    {{ $t('ปิดหน้าต่าง') }}
                </a-button>
            </div>
        </a-modal>
        <a-modal centered v-if="step == 'scan'" :bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
            <div class="custom-modal-header">
                <label class="custom-modal-header-title fs-20">
                    {{ data.title }}
                </label>
            </div>
            <div class="custom-modal-body">
                <label class="custom-modal-body-detail fs-16">
                    {{ data.message }}
                </label>
            </div>
            <!-- footer -->
            <div class="custom-modal-footer">
                <a-button key="back" class="custom-modal-footer-single-close-btn fs-20" @click="cancel()">
                    {{ $t('ยกเลิก') }}
                </a-button>
            </div>
        </a-modal>
    </div>
</template>
<script>
export default {
    props: ['visible', 'step', 'data'],
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: 'form_in_modal' });
    },
    data() {
        return {};
    },
    methods: {
        cancel() {
            this.$emit('on-cancel');
        },
        create() {
            this.$emit('on-save');
        },
    },
};
</script>
<style scoped>
.custom-modal-header {
    background: transparent;
    padding-bottom: 0;
    text-align: center;
}
.custom-modal-header-title {
    color: #141322 !important;
    font-weight: 600;
}
.custom-modal-body {
    background: transparent;
    /* padding: 16px 10px; */
    padding-bottom: 0;
    text-align: center;
}
.custom-modal-body-detail {
    color: #141322 !important;
    font-weight: 300;
}
.custom-modal-footer {
    background: transparent;
    padding: 16px 10px;
}
.custom-modal-footer-single-close-btn {
    background: linear-gradient(0deg, #ff7105, #ff9500 100%) no-repeat;
    color: #fff;
    width: 100%;
}
</style>